<template>
  <div>
    <div class="tips">
      <img src="@/assets/img/asterisk_red.png" alt="" />{{ peopleType === 'GT_I' ? $t('infoTipGti') : $t('infoTip') }}
    </div>
    <div class="tip-line"></div>
    <van-form @submit="onSubmit" ref="myForm" :disabled="formDisabled">
      <van-collapse :class="$i18n.locale" v-model="activeNames">
        <van-collapse-item :title="key.replace(/(.*)<<.*?\]\]$/, '$1')" v-for="(value, key, idx) in activities" :key="idx"
          :name="idx">
          <div class="tips" v-if="$i18n.locale !== 'en' && value[0].typeTipCn"><img src="@/assets/img/asterisk_red.png" alt="" />{{ $t1(value[0], 'typeTip') }}</div>
          <div class="tips" v-if="$i18n.locale === 'en' && value[0].typeTipEn"><img src="@/assets/img/asterisk_red.png" alt="" />{{ $t1(value[0], 'typeTip') }}</div>
          <van-field name="checkboxGroup">
            <template #input>
              <van-checkbox-group v-model="checkboxGroup[idx]" @change="checkChange">
                <van-checkbox :name="index" :disabled="formDisabled" shape="square" v-for="(item, index) in value"
                  :key="index">
                  <div class="title">{{ $t1(item, 'name') }}</div>
                  <div class="time"><img src="@/assets/img/clockImg.svg" alt="" />{{ (item.dateStr ?
                    item.dateStr.substring(5) : '') + ' ' + (item.startTime ? item.startTime.substring(0, 5) : '') + '-' +
                    (item.endTime ? item.endTime.substring(0, 5) : '') }}</div>
                  <div class="address"><img src="@/assets/img/address.png" alt="" />{{ $t1(item, 'placeName') }}</div>
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </van-collapse-item>
      </van-collapse>

      <!-- 原演讲稿 -->
      <div class="line"></div>
      <div class="information-box">
        <div class="information-title">{{ $t('form.title.statement') }}</div>
        <div class="item item2">
          <van-field name="test" class="img-upload">
            <template #input>
              <van-uploader accept=".doc,.docx,.ppt,.pptx,.pdf,.rar,.zip,.7z" v-model="fileList.statement"
                :after-read="afterRead" @delete="deleteStatement" :max-count="1" :upload-text="$t3('上传文件', 'Upload')"
                :before-delete="() => !formDisabled" />
            </template>
            <template #label>{{ $t('statementDia.title') }}
              <img src="@/assets/img/infoIcon01.svg" alt="" @click="tipShow = true" />
            </template>
          </van-field>
        </div>
      </div>
    </van-form>
    <van-dialog v-model="tipShow" :title="$t('form.title.statement')" theme="round-button"
      :confirm-button-text="$t('gotIt')" class="notice-dialog">
      <div class="notice-dialog-body">
        <div>{{ $t('statementDia.article1') }}</div>
        <div>{{ $t('statementDia.article2') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { objectMergLeft } from '@/utils'
import { getActivityAll } from '@/api/activity'
import { mapGetters } from 'vuex'
import { toMedia } from '@/utils/request'
import { addFile } from '@/api/file'

const tmpForm = {
  id: undefined,
  wantRecord: undefined,
  statement: undefined,
  statementName: undefined
}

export default {
  name: 'activityInte',
  props: ['formDisabled'],
  data() {
    return {
      form: {},
      activeNames: [0],
      checkboxGroup: [],
      activities: {},
      activityKeyDict: [],
      activityValueDict: {},
      fileList: {
        statement: []
      },
      tipShow: false,
      uploadLoading: false
    }
  },
  computed: {
    ...mapGetters(['peopleType', 'activityPlan', 'joinState']),
    fileType() {
      return this.form.statement ? this.form.statement.substring(this.form.statement.lastIndexOf('.')) : ''
    }
  },
  watch: {
    fileList: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          const x = document.querySelector('.van-uploader__file-name')
          if (x) {
            // x.innerHTML = this.$t('form.title.statement') + this.fileType
            x.innerHTML = decodeURI(this.form.statementName)
          }
        })
      },
      immediate: true
    },
    form: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          const x = document.querySelector('.van-uploader__file-name')
          if (x) {
            // x.innerHTML = this.$t('form.title.statement') + this.fileType
            x.innerHTML = decodeURI(this.form.statementName)
          }
        })
      }
    }
  },
  mounted() {
    this.getActivityAll()
  },
  methods: {
    initForm(form) {
      this.fileList = {
        statement: []
      }
      this.form = Object.assign({}, tmpForm)
      objectMergLeft(this.form, form)
      if (this.form.wantRecord) {
        this.checkboxGroup = this.checkboxGroup.map(() => [])
        const keyList = this.form.wantRecord.split(',')
        for (const key of keyList) {
          const value = this.activityValueDict[key]
          if (value && this.checkboxGroup[value[0]]) {
            this.checkboxGroup[value[0]].push(parseInt(value[1]))
          }
        }
      }
      if (this.form.statement) {
        this.fileList.statement = [{
          url: toMedia(this.form.statement),
          isImage: false
        }]
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        if (this.uploadLoading) {
          this.$notify(this.$t3('有图片上传中，请稍后再试', 'Please wait for the picture being uploaded.'))
          reject(); return
        }
        resolve(true)
      })
    },
    getActivityAll() {
      getActivityAll({ conferenceId: this.$route.params.conferenceId, activityIds: this.activityPlan }).then(res => {
        this.activities = res.data
        this.checkboxGroup = []
        this.activityKeyDict = []
        // 默认展开全部
        this.activeNames = []
        Object.keys(this.activities).forEach((x, i) => {
          let arr = []
          const tmpList = []
          for (const j in this.activities[x]) {
            const activity = this.activities[x][j]
            tmpList.push(activity.id)
            this.activityValueDict[activity.id] = [i, j]
            if (this.peopleType === "GT_I") {
              arr.push(parseInt(j))
            }
          }
          this.checkboxGroup.push(arr)
          this.activityKeyDict.push(tmpList)
          // 默认展开全部
          this.activeNames.push(i)
        })
      })
    },
    checkChange() {
      this.form.wantRecord = ''
      const tmpActivities = []
      for (const i in this.checkboxGroup) {
        if (this.checkboxGroup[i] && this.checkboxGroup[i].length) {
          for (const j in this.checkboxGroup[i]) {
            tmpActivities.push(this.activityKeyDict[i][this.checkboxGroup[i][j]])
          }
        }
      }
      this.form.wantRecord = tmpActivities.join()
    },
    onSubmit(values) {
      console.log('submit', values)
    },
    goNext() {
      this.$router.push('tripInfo')
    },
    goPrev() {
      this.$router.push('contactInfo')
    },
    deleteStatement() {
      this.form.statement = ''
    },
    afterRead(params) {
      const file = params.file
      const limit50MB = 50 * 1024 * 1024
      if (file && file.size > limit50MB) {
        this.$notify('文件大小超出限制')
        this.fileList.statement.pop()
        return
      }
      this.uploadLoading = true
      addFile({ conferenceId: this.$route.params.conferenceId, file: file }).then(response => {
        if (response.code && response.code === 200) {
          this.form.statement = response.data
          this.form.statementName = encodeURI(params.file.name)
        } else {
          this.fileList.statement.pop()
        }
        this.uploadLoading = false
      }, () => {
        this.uploadLoading = false
        this.fileList.statement.pop()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: calc(100vh - 157px);
  margin: 0 0 -60px;
  background: #F2F4F6;
  // overflow-y: auto;
}
</style>